import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlashCards = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2226 18C18.1893 20.2457 16.0087 21 12.0004 21C7.99213 21 5.81112 20.2457 4.77759 18",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 9.5C3 4.44444 5.00092 3 12.0005 3C19 3 21 4.44444 21 9.5C21 14.5556 18.9231 16 12.0005 16C5.07784 16 3 14.5556 3 9.5Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 9.5L9.83605 7.96996C10.3726 7.52279 10.6409 7.29921 10.925 7.35862C11.209 7.41804 11.3652 7.73041 11.6776 8.35517L12.3224 9.64483C12.6348 10.2696 12.791 10.582 13.075 10.6414C13.3591 10.7008 13.6274 10.4772 14.164 10.03L16 8.5",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFlashCards);
export { ForwardRef as ReactComponent };
